<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card flat class="pa-1">
        <v-btn text @click="isView = !isView" color="primary">
            {{!isView ? "表示オプションを表示する" : "表示オプションを隠す"}}
        </v-btn>
        <v-expand-transition>
            <v-card v-if="isView" outlined class="pa-1" color="grey lighten-4">
                <!-- <v-toolbar dense flat v-if="!$vuetify.breakpoint.xs">
                    <v-checkbox v-model="controlValues.enabledYAxisFitValue" label="Y軸自動" style="white-space:nowrap" hide-details />
                    <v-select
                        v-model="controlValues.height"
                        prefix="チャートの高さ"
                        :items="heights"
                        item-text="text"
                        item-value="value"
                        hide-details
                        class="ml-2" />
                </v-toolbar>
                <v-simple-table v-else dense>
                    <tr>
                        <td>
                            <v-checkbox v-model="controlValues.enabledYAxisFitValue" label="Y軸を自動調整" dense class="ma-0" hide-details />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <v-select
                                v-model="controlValues.height"
                                prefix="チャートの高さ"
                                :items="heights"
                                item-text="text"
                                item-value="value"
                                hide-details
                                dense />
                        </td>
                    </tr>
                </v-simple-table> -->
                <v-container fluid class="pa-0">
                    <v-row dense>
                        <v-col cols="12" xs="12" sm="2" md="2" lg="2" xl="2">
                            <v-checkbox v-model="controlValues.enabledYAxisFitValue" label="Y軸を自動" style="white-space:nowrap" hide-details />
                        </v-col>
                        <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="3">
                            <v-select
                                v-model="controlValues.height"
                                prefix="チャートの高さ"
                                :items="heights"
                                item-text="text"
                                item-value="value"
                                hide-details
                                class="ml-2" />
                        </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col>
                            <v-slider v-model="controlValues.zoom" label="拡大" :min="0" :max="1" :step="0.01" hide-details />
                        </v-col>
                    </v-row>
                    <!-- <v-row dense>
                        <v-col cols="12" xs="12" sm="5" md="6" lg="6" xl="6">
                            <v-slider v-model="controlValues.position" :min="0" :max="1" :step="0.01" hide-details label="位置" />
                        </v-col>
                        <v-col cols="12" xs="12" sm="7" md="6" lg="6" xl="6" align-self="center">
                            <v-chip small>
                                {{new Date(controlValues.from()).toFormatString("MM月dd日 HH時mm分")}}
                            </v-chip>
                            ～
                            <v-chip small>
                                {{new Date(controlValues.to()).toFormatString("MM月dd日 HH時mm分")}}
                            </v-chip>
                        </v-col>
                    </v-row> -->
                </v-container>
            </v-card>
        </v-expand-transition>
    </v-card>
</template>

<script>
    export default {
        props: {
            controlValues: null
        },
        data: function () {
            return {
                isView: false,
                heights: [
                    {value:300, text:"最小"},
                    {value:400, text:"小"},
                    {value:600, text:"標準"},
                    {value:800, text:"大"},
                    {value:1000, text:"最大"},
                ]
            }
        },
    }
</script>
